import React from "react";
import "../assets/css/Certificate.css";
import certificate from "../assets/img/mdeolo.png";

const Certificate = () => (
  <div className="certificate ">
    <div className="row justify-content-center align-items-center">
      <img className="img-fluid img-certificate img-certificate-descktop d-none d-xl-block "  src={certificate} alt="Certificado"/>
      <div className="container-certificate d-flex flex-column justify-content-center align-items-start ">
        {/* <h1 className="title-certificate">Somos Certificados para</h1> */}
        {/*<h1 className="title-certificate-top text-white">Somos Certificados para </h1>*/}
        {/*<h1 className="title-certificate-b title-certificate-subtitle text-white">Garantir a Melhor Qualidade </h1>*/}
        <h1 className="title-certificate-b title-certificate-subtitle text-white">Excelência Comprovada </h1>
        <img className="img-fluid img-certificate align-self-center img-certificate-descktop d-block d-xl-none"  src={certificate} alt="Certificado"/>

        <p className="text-certificate text-white">
          Com a certificação MPSBR Nível C, concedida pela Softex, garantimos
          soluções de software que atendem aos mais altos padrões de qualidade e
          eficiência. Reconhecidos nacional e internacionalmente, entregamos
          resultados que impulsionam o sucesso do seu negócio.
        </p>
      </div>


    </div>
    <div id="products-container"></div>
  </div>
);

export default Certificate;
